import { Problem } from '@sportik/api-coach/problem';
import { ErrorState } from '@sportik/ui/components/ErrorState';
import { useLocation, useNavigate, useRouteError } from 'react-router';
import { problemCopy } from '@/lib/problem-copy';
import { NotAllowed } from './NotAllowed';

// Refusals of the account itself: the same answer however often it is asked.
const REFUSED = new Set([
  'signup_not_allowed',
  'email_not_verified',
  'account_exists',
]);

/**
 * The router's own boundary: whatever a route throws lands here. A loader that
 * awaits a read fails with a `Problem`, named by its `code`; anything else is a
 * render that broke. Retrying navigates to the same URL again, which is what
 * clears the router's error — revalidating only re-runs loaders and leaves a
 * failed render in place.
 */
export function RouteError() {
  const error = useRouteError();
  const location = useLocation();
  const navigate = useNavigate();

  if (error instanceof Problem && REFUSED.has(error.code)) {
    return <NotAllowed {...problemCopy(error.code)} />;
  }

  const copy =
    error instanceof Problem
      ? problemCopy(error.code)
      : {
          title: 'This screen failed to load',
          description: error instanceof Error ? error.message : undefined,
        };

  return (
    <ErrorState
      {...copy}
      onRetry={() => {
        void navigate(location.pathname + location.search, { replace: true });
      }}
    />
  );
}
